var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gutters",class:{ reverse: _vm.reverse }},[_c('img',{attrs:{"src":require("@/assets/img/illustrations/gutters.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(this.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }